// Testimonies from past WCMC attendees
// Ordered by Terri's ranking (Cheri P is #1, etc.)
// Primary = shown on home page. All = shown on full testimonies page.

export const TESTIMONIES = [
  {
    id: 'cheri-p',
    name: 'Cheri P',
    primary: true,
    quote: "I came in callused. Through this Marriage Camp, God broke down long-held barriers. He restored hope, healing, and brought new life into our marriage!"
  },
  {
    id: 'justin-l',
    name: 'Justin L',
    primary: true,
    quote: "The Marriage Camp weekend was more than I had hoped for. It was not a surface level retreat. It guided us into a deeper level of intimacy and honesty with each other. I now have a better understanding of how to love and cherish my wife's heart."
  },
  {
    id: 'erika-g',
    name: 'Erika G',
    primary: true,
    quote: "I was done with our superficial, just practical marriage — all shiny on the outside and empty on the inside. I cried out to God for an authentic and honest marriage. God broke through and revealed the core of our doubts, fears, pride, and ego to rescue our marriage."
  },
  {
    id: 'darren-k',
    name: 'Darren K',
    primary: false,
    quote: "The impact of each session opened the doors to communication and brought down the walls that had been between us our entire marriage. Exposing our false self and learning about our true selves has given me the confidence to fight for my wife's heart."
  },
  {
    id: 'sandra-g',
    name: 'Sandra G',
    primary: false,
    quote: "I always sensed that something was being held over my husband's life, like the enemy was after him. Jesus came crashing over him with love this weekend, and I got to be the person he trusted to help him heal. The Lord traded shame for peace."
  },
  {
    id: 'mick-eva',
    name: 'Mick and Eva',
    primary: false,
    quote: "We have been married for 37 years and we have always loved each other, but after this weekend, we now feel in love like we did when we were 16 years old!"
  },
  {
    id: 'ken-g',
    name: 'Ken G',
    primary: false,
    quote: "Thank you for addressing what I see is a gap in Christian ministry — REAL topics in marriage."
  },
  {
    id: 'lisa-h',
    name: 'Lisa H',
    primary: false,
    quote: "We left the weekend with more hope, more happiness, and a renewed closeness in our marriage. I am grateful for the healing, the connection, and the gentle reminders of what truly matters."
  },
];
